"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AspectRegistry = new Map();
exports.Targets = new Set();
function resetRegistry() {
    exports.AspectRegistry = new Map();
    exports.Targets = new Set();
}
exports.resetRegistry = resetRegistry;
var Aspect = (function () {
    function Aspect() {
        this.pointcuts = [];
    }
    Aspect.prototype.wove = function (target, woveMetadata) {
        this.pointcuts.forEach(function (p) {
            p.apply(target, woveMetadata);
        });
    };
    return Aspect;
}());
exports.Aspect = Aspect;
